import { render, staticRenderFns } from "./mock-define.vue?vue&type=template&id=4b179840&"
import script from "./mock-define.vue?vue&type=script&lang=ts&"
export * from "./mock-define.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports